export const validDimensions = [
  "1024x768",
  "970x250",
  "970x90",
  "768x1024",
  "728x90",
  "480x320",
  "468x60",
  "336x280",
  "320x480",
  "320x100",
  "320x50",
  "300x1050",
  "300x600",
  "300x250",
  // "300x100",
  "800x1100",
  "300x50",
  "250x250",
  "216x36",
  "200x200",
  "180x150",
  "168x28",
  "160x600",
  "120x600",
  "120x240",
  "120x60",
  "120x20",
];

export const invalidFileTypeVideoErrorMessage =
  "Because you chose a non-video (display) campaign, you are only able to upload images/gifs for this campaign, not videos.";

export const invalidFileTypeImageErrorMessage =
  "Because you chose a video campaign, you are only able to upload videos for this campaign, not images.";

export const videoDuration = [30, 15];
